// libraries
import { Root } from '@makemydeal/dr-activities-change-vehicle';

// consts/enums
import { CHANGE_VEHICLE_ROUTE_ROOT } from '../constants';

const ChangeVehicleContainer = () => {
    return <Root baseRoute={CHANGE_VEHICLE_ROUTE_ROOT} showReturnToOffer={true} />;
};

export default ChangeVehicleContainer;
